import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react'
import { isValidToken, storeToken, getToken, getUser } from './auth'

interface AuthContextType {
  isLoggedIn: boolean
  user?:{
      username: string,
      kind: "advertiser" | "publisher",
      email?: string,
      companyName?: string,
      switchAccessUsernames?: string[],
      switchedFrom?: {username: string},
      settings: {
        currency: string,
        company?: {
          name?: string,
          website?: string,
          domains?: string[],
          contactEmail?: string,
          vatNumber?: string,
        }
      },
      admin?: {username: string}
      isAdmin?:boolean
      byClick?: {enabled: boolean}
        partnerships?: {enabled: boolean}
  },
  login: (token: string) => void
  logout: () => void
  getToken: () => string
}

const AuthContext = createContext<AuthContextType | undefined>(undefined)

export const useAuth = () => {
  const context = useContext(AuthContext)
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider')
  }
  return context
}

export const AuthProvider: React.FC<{children: ReactNode}> = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(isValidToken)
  const [user, setUser] = useState(getUser)

  useEffect(() => {
    const checkTokenValidity = () => {
      const isValid = isValidToken()
      setUser(getUser())
      setIsLoggedIn(isValid)
    }

    checkTokenValidity()
  }, [])

  const login = (token: string) => {
    storeToken(token)
    setIsLoggedIn(true)
    setUser(getUser())
  }

  const logout = () => {
    localStorage.removeItem('authToken')
    setIsLoggedIn(false)
    setUser(undefined)
  }

  const getToken0 = () => {
    return getToken()
  }

  return (
    <AuthContext.Provider value={{ isLoggedIn, login, logout, getToken:getToken0, user: user as any }}>
      {children}
    </AuthContext.Provider>
  )
}
